import { useGate, useUnit } from 'effector-react'
import {
  $articleList,
  $modalArticle,
  $modalDeleteArticle,
  $modalDeleteArticleItem,
  BudgetCategoriesGate,
} from 'src/pages/budget/budgetCategories/model'
import { getArticleListFx } from 'src/pages/budget/model'

export const useBudgetCategoriesGate = () => useGate(BudgetCategoriesGate)

export const useArticleList = () => {
  const articleList = useUnit($articleList)
  const loadingArticleList = useUnit(getArticleListFx.pending)

  return { articleList, loadingArticleList }
}

export const useModalArticle = () => useUnit($modalArticle)

export const useModalDeleteArticle = () => useUnit($modalDeleteArticle)

export const useModalDeleteArticleItem = () => useUnit($modalDeleteArticleItem)
